import loading from "../../../../core/widgets/loading";
import { openPopup } from "../../../../core/widgets/popup";
import { Notifier as notifier } from "../../../../core/widgets/notifier";
import { MODAL_LOGIN } from "../../../../core/modals";
import { siteUrl } from "../../../../core/utils/url";
import { CartItem } from "./cartitem";
import { CartShopView } from "./cartshopview";
import { CartPriceComponents } from "./cartpricecomponents";
import { reloadNpOffices } from "../../../blocks/delivery_data_form/utils";

const cartKey = 'cart';

export class Cart {
    irGroupId = ko.observable(null);
    maxPrice = 100;
    maxQuantity = Number.MAX_SAFE_INTEGER;
    items = ko.observableArray();
    shopViews = ko.observableArray();
    additionalInfo = ko.observable(null);
    termsAccepted = ko.observable(false);
    passportTermsAccepted = ko.observable(false);
    checkingTypes = null;
    irWeightPrice = null;
    _previousAddresses = [];

    totalPriceComponents = ko.pureComputed(() => {
        let sum = new CartPriceComponents();

        this.items().forEach(
            item => sum.add(item.priceComponents(), item.amount())
        );

        return sum;
    });

    shippingPrice = ko.pureComputed(
        () => this.shopViews().reduce((sum, view) => sum + view.shippingPrice(), 0)
    );

    total = ko.pureComputed(() => {
        const result = this.totalPriceComponents().total() + this.shippingPrice();
        return result.toFixed(2);
    });

    isShippingPriceUnknown = ko.pureComputed(
        () => this.shopViews().reduce((result, view) => result || view.isShippingPriceUnknown(), false)
    );

    moneyLeft = ko.pureComputed(() => this.maxPrice - this.totalPriceComponents().price);

    isSubmitting = ko.observable(false);
    isEmpty = ko.pureComputed(() => this.items().length === 0);
    canCreateOrder = ko.pureComputed(
        () => !this.isSubmitting() && !this.isEmpty() && this.termsAccepted()
            && this.passportTermsAccepted()
            && this.shopViews().reduce((result, view) => result && view.isMinPriceReached(), true)
    );

    constructor(options, autoUpdate = true) {
        registerTemplates();
        const o = {
            checkingTypes: {},
            irWeightPrice: 0,
            previousAddresses: [],
            ...options
        };

        this.checkingTypes = o.checkingTypes;
        this.irWeightPrice = parseFloat(o.irWeightPrice);
        this._previousAddresses = o.previousAddresses;

        if (autoUpdate) {
            // Reload data when changed in storage
            $(window).on('storage', (e) => {
                if (e.originalEvent.key == cartKey) {
                    this.load();
                }
            });

            // Reload data when changed externally
            $(window).on('cart-updated-externally', () => this.load());

            // Save changed data to storage
            $(window).on('cart-item-changed', () => this.save());
        }

        if (this._previousAddresses.length) {
            const $form = $('.delivery-form');
            const $previousAddressSelect = $('#previousAddressSelect');
            const $npOfficeSelect = $('select[name=np_office]');

            $previousAddressSelect.change((e, data) => {

                if (data.selected) {
                    const address = this._previousAddresses.find(a => a.id == data.selected);

                    if (address) {
                        for (let prop in address) {
                            if (['customer_id', 'np_city_description', 'np_office_description', 'last_used_date', 'np_office_ref'].includes(prop)) {
                                continue;
                            }
                            if (prop == 'np_city_ref') {
                                $form.find(`[name=np_city]`).val(address.np_city_ref).trigger('chosen:updated');
                                $form.find(`[name=np_city]`).closest('.form-row').addClass('z-valid');
                                reloadNpOffices(
                                    $form.find(`[name=np_office]`),
                                    address.np_city_ref,
                                    'novaposhta',
                                    () => this.setFormNpOffice(address.np_office_ref)
                                );
                            } else {
                                $form.find(`[name=${prop}]`).val(address[prop]).trigger('chosen:updated');
                            }
                        }

                        $form.valid();
                    }
                } else {
                    $form.find('input').val('');
                    $form.find('.form-row').removeClass('z-valid');
                    $form.find('[name=np_office]').children().remove();
                    $form.find('[name=np_office]').append(`<option disabled>Сначала выберите город</option>`);
                    $form.find('[name=np_city],[name=np_office]').val('').trigger('chosen:updated');
                }
            });

            $npOfficeSelect.change(() => {
                if ($npOfficeSelect.val()) {
                    $npOfficeSelect.closest('.form-row').removeClass('z-notice');
                    $('.delivery-form').validate().element($npOfficeSelect);
                }
            });

            $form.find('input,[name=np_office],[name=np_city]').keyup(
                () => $previousAddressSelect.val('').trigger('chosen:updated')
            );
        }
    }

    load(rawData = null) {
        const data = this.loadData(rawData);

        this.items.removeAll();
        this.items.pushAll(data.items);
        this.irGroupId(data.irGroupId || null);
        this.updateShopViews();
    }

    /**
     * @param {CartItem} item
     * @return {boolean}
     */
    addItem(item) {
        let result = false;

        try {
            if (this.canAdd(item.sum * item.amount())) {
                // If this product already exist, merge
                let merged = false;
                for (let cItem of this.items()) {
                    const match = cItem.order_id == item.order_id
                        && cItem.additional_customer == item.additional_customer
                        && cItem.additional_customer_raw == item.additional_customer_raw
                        && cItem.size == item.size
                        && cItem.variant == item.variant
                        && cItem.sale_id == item.sale_id;
                    if (match) {
                        cItem.amount(parseInt(cItem.amount()) + parseInt(item.amount()));
                        merged = true;
                        break;
                    }
                };

                if (!merged) {
                    this.items.push(item);
                    this.updateShopViews();
                }
                this.save();
                result = true;
            }
        } catch(e) {
            console.log(e);
        }

        return result;
    }

    /** @param {CartItem} item */
    deleteItem(item) {
        this.items.remove(item);
        if (this.items().length > 0) {
            this.updateShopViews();
            this.save();
        } else {
            this.clear();
        }
    }

    clear() {
        this.additionalInfo(null);
        this.shopViews.removeAll();
        this.items.removeAll();
        Cart._clearData();
    }

    save() {
        Cart._saveData(this.getData());
    }

    post() {
        if (IS_LOGGED_IN) {
            this._postOrders()
        } else {
            MODAL_LOGIN.show(data => {
                if (data) {
                    this._postOrders();
                }
            });
        }
    }

    _postOrders() {
        const $deliveryForm = $('.delivery-form');
        const groups = this.shopViews().map(view => ({
            items: view.items().map(item => item.serializeArray()),
            shop: view.shop,
            // sale_id: view.selectedSaleId().length ? view.selectedSaleId()[0].id : null,
            shipping_price: view.shippingPrice()
        }));
        const data = {
            groups,
            additional_info: this.additionalInfo(),
            delivery_data: {},
            ir_group_id: this.irGroupId(),
            raw_cart_data: JSON.stringify(this.getData())
        };

        if (!$deliveryForm.valid()) {
            return;
        }

        $deliveryForm.serializeArray().forEach(item => data.delivery_data[item.name] = item.value);

        this.isSubmitting(true);
        loading.show();

        $.post(
            siteUrl('packages/save_orders_individual'),
            { data },
            null,
            'json'
        )
            .done(response => {
                if (response && response.success) {
                    this._showSuccessMessage(response, data.delivery_data);
                    this.clear();
                    if (window.fbq) fbq('track', 'AddToCart');
                } else {
                    const error = response && response.error ? response.error : 'Ошибка';
                    notifier.error(error);
                }
            })
            .always(() => {
                loading.hide();
                this.isSubmitting(false);
            })
            .fail(() => notifier.errorXHR());

    }

    canAdd(price, reload = true) {
        if (reload) {
            this.load();
        }
        return this.totalPriceComponents().price + Number(price) <= this.maxPrice;
    }

    redirectToOrderForm() {
        window.location = siteUrl('create_order_individual');
    }

    updateShopViews() {
        const itemShops = new Set(this.items().map(item => item.custom_sender_name));
        const viewShops = new Set(this.shopViews().map(view => view.shop));

        // Delete empty views
        this.shopViews().forEach(view => {
            if (!itemShops.has(view.shop)) {
                this.shopViews.remove(view);
            }
        });

        // Add missing views
        this.items().forEach(item => {
            if (!viewShops.has(item.custom_sender_name)) {
                this.shopViews.push(new CartShopView(item.custom_sender_name, item.shopInfo, this));
                viewShops.add(item.custom_sender_name)
            }
        });
    }

    /**
     * @param {Object} data
     * @param {Object} deliveryData
     * @private
     */
    _showSuccessMessage(data, deliveryData) {
        const ci = data.currency_info;
        const tmpl = data.low_balance ? 'cs-popup-success-low-balance' : 'cs-popup-success';
        const tmplData = {
            ...deliveryData,
            balance_link: siteUrl('balance'),
            debt_euro_f: numeral(data.debt).format('0.00') + ' &euro;',
            debt_converted_f: numeral(data.debt * ci.rate).format('0.00') + ' ' + ci.sign,
            currency_rate_f: numeral(ci.rate).format('0.00'),
            currency_sign: ci.sign
        };
        openPopup($.tmpl(tmpl, tmplData), {
            onClose: () => window.location = siteUrl('show_user_parcels/all'),
            cssClass: 'create-order-popup'
        });
    }

    /**
     * @param {Object}|null data
     * @return {Object}
     * */
    loadData(data = null) {
        if (!data) {
            const jsonData = localStorage.getItem(cartKey);
            data = (jsonData === null) ? Cart._getDummyData() : JSON.parse(jsonData);
        }

        data.items = data.items.map(item => new CartItem(item, this));

        return data
    }

    /** @return {Object} */
    getData() {
        return {
            irGroupId: this.irGroupId(),
            items: this.items().map(item => item.serializeArray()),
            total: this.total()
        };
    }

    /**
     * @param float value
     * @returns string
     */
    formatPrice(value) {
        const formatted = value !== null ? value.toFixed(2) : 0;
        return formatted > 0 ? formatted : '0';
    }

    /**
     * @param int id
     * @param string serializedData
     */
    editOrder(irGroupId, serializedData) {
        if (irGroupId && serializedData) {
            const data = JSON.parse(serializedData);
            data.irGroupId = irGroupId;

            // Load data to recalculate total price and save it
            this.load(data);
            this.save();

            // Redirect to cart page
            setTimeout(() => window.location = siteUrl('cart'));
        }
    }

    setFormNpOffice(officeRef) {
        const $select = $('select[name=np_office]');
        if ($select.length) {
            let newValue = '';
            let isNpOfficeNotAvailable = false;

            if (officeRef) {
                if ($select.find(`option[value='${officeRef}']`).length) {
                    newValue = officeRef;
                } else {
                    isNpOfficeNotAvailable = true;
                }
            }

            $select.val(newValue).trigger('change').trigger('chosen:updated');
            if (isNpOfficeNotAvailable) {
                $select.closest('.form-row').addClass('z-notice');
            } else {
                $select.closest('.form-row').removeClass('z-notice');
            }
        }
    }

    static clearData() {
        Cart._clearData();
        $(window).trigger('cart-updated-externally');
    }

    /** @param {Object} data */
    static _saveData(data) {
        const jsonData = JSON.stringify(data);
        localStorage.setItem(cartKey, jsonData);

        // Trigger event to notify listeners in the current window
        $(window).trigger('cart-updated');
    }

    static _clearData() {
        Cart._saveData(Cart._getDummyData());
    }

    /** @return {Object} */
    static _getDummyData(data) {
        return { items: [], total: 0, irGroupId: null };
    }

}

function registerTemplates() {
    $.template('cs-popup-success', require('../templates/cs-popup-success.html'));
    $.template('cs-popup-success-low-balance', require('../templates/cs-popup-success-low-balance.html'));
}


// WEBPACK FOOTER //
// ./modules/packages/common/model/cart.js